import { type FC, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { getIsLineFinished, getIsPregameLine, selectUserIsAuthenticated, usePrevious, useWidgetUrl } from '@mwl/core-lib';
import { useMediaWidthDown, useTypedSelector } from '@/hooks';
import { WidgetBanner } from '../WidgetBanner/WidgetBanner';
import type { MatchWidgetProps } from './MatchWidget.types';
import styles from './MatchWidget.module.scss';
export const MatchWidget: FC<MatchWidgetProps> = ({
  line,
  className,
  activeTab
}) => {
  const [isWidgetUrlChanged, setIsWidgetUrlChanged] = useState<boolean>(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const isMobile = useMediaWidthDown('screen850');
  const widgetUrl = useWidgetUrl({
    line,
    activeTab,
    isMobile
  });
  const prevWidgetUrl = usePrevious(widgetUrl);
  const isLineFinished = getIsLineFinished(line);
  const isLineNotStarted = getIsPregameLine(line);
  const isActiveTabBroadcast = activeTab === 'broadcast';
  const shouldShowBanner = !isAuth || (isLineFinished || isLineNotStarted) && isActiveTabBroadcast;
  const handleIframeOnload = () => {
    setIsWidgetUrlChanged(false);
  };
  useLayoutEffect(() => {
    if (widgetUrl !== prevWidgetUrl) {
      setIsWidgetUrlChanged(true);
    }
  }, [prevWidgetUrl, widgetUrl]);
  useEffect(() => {
    if (widgetUrl && prevWidgetUrl !== widgetUrl) {
      iframeRef.current?.contentWindow?.location.replace(widgetUrl);
    }
  }, [widgetUrl, prevWidgetUrl]);
  if (!widgetUrl) {
    return null;
  }
  return <div className={cn(styles.root, className, {
    [styles.banner]: shouldShowBanner,
    [styles.broadcast]: !shouldShowBanner && isActiveTabBroadcast && !isWidgetUrlChanged
  })} data-sentry-component="MatchWidget" data-sentry-source-file="MatchWidget.tsx">
      {shouldShowBanner && <WidgetBanner isAuth={isAuth} isLineFinished={isLineFinished} isLineNotStarted={isLineNotStarted} title={line.sport.title} />}
      {!shouldShowBanner && <iframe ref={iframeRef} className={cn(styles.iframe, {
      [styles.hideWidget]: isWidgetUrlChanged
    })} src={widgetUrl} title={activeTab} onLoad={handleIframeOnload} loading="lazy" />}
    </div>;
};